import { NgModule, APP_INITIALIZER } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core'
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { CacheService } from './services/cache.service'
import { MissingI18nService } from './services/missing-i18n.service'
import { ShowErrorsComponent } from './components/show-errors.component'
import { FormErrorsComponent } from './components/form-errors.component'
import { ButtonComponent } from './components/button.component'
import { LoadingIndicatorComponent } from './components/loading-indicator.component'
import { ConfirmActionDirective } from './components/confirm-action.directive'
import { LocalizedDatePipe } from './pipes/localized-date.pipe'

import { ToastrModule } from 'ngx-toastr'
import { LoginComponent } from './components/login.component'
import { RouterModule } from '@angular/router'
import { DefaultLayoutComponent } from './components/default-layout'
import { SidebarComponent } from './components/sidebar/sidebar.component'
import { MenuComponent } from './components/menu/menu.component'
import { InlineProfileComponent } from './components/inline-profile/inline-profile.component'
import { BreadcrumbsComponent } from './components/breadcrumbs.component'
import { P404Component } from './components/404.component'
import { P403Component } from './components/403.component'
import { P500Component } from './components/500.component'
import { PageComponent } from './components/page.component'
import { NgSelectModule } from '@ng-select/ng-select'

import { ContribRenderExtensionModule } from '@angular-contrib/core'
import { ContribNgNoHostModule } from '@angular-contrib/common'
import { TokenInterceptor } from './services/token-interceptor'
import { RemoveHost } from './components/remove-host.component'
import { NgxColumnModePipe } from './pipes/ngx-column-mode.pipe'
import { SortPipe } from './pipes/sort.pipe'

import { BsDropdownModule } from 'ngx-bootstrap/dropdown'

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

export function initializeAppCache(cacheService: CacheService) {
    return (): Promise<any> => {
        return cacheService.init()
    }
}
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        // OverlayPanelModule,
        RouterModule.forChild([]),
        ToastrModule.forRoot(),
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MissingI18nService,
            },
            isolate: false,
        }),
        BsDropdownModule.forRoot(),
        // ContribNgNoHostModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        ToastrModule,
        NgSelectModule,
        BsDropdownModule,

        LoginComponent,
        ShowErrorsComponent,
        FormErrorsComponent,
        ButtonComponent,
        LoadingIndicatorComponent,
        ConfirmActionDirective,
        LocalizedDatePipe,
        NgxColumnModePipe,
        SortPipe,
        RemoveHost,

        DefaultLayoutComponent,
        P404Component,
        P403Component,
        P500Component,
        PageComponent,
    ],
    declarations: [
        LoginComponent,
        ShowErrorsComponent,
        FormErrorsComponent,
        ButtonComponent,
        LoadingIndicatorComponent,
        ConfirmActionDirective,
        LocalizedDatePipe,
        NgxColumnModePipe,
        SortPipe,
        DefaultLayoutComponent,
        SidebarComponent,
        MenuComponent,
        InlineProfileComponent,
        BreadcrumbsComponent,
        P404Component,
        P403Component,
        P500Component,
        PageComponent,
        RemoveHost,
    ],
    providers: [
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: initializeAppCache,
        //     deps: [CacheService],
        //     multi: true,
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
    ],
})
export class CoreModule {}
